import _get from 'lodash/get'
import { isFullUrl } from '../../services/url/index'
import { URL_HOME } from '../../services/url/constants'
import { historyRedirect, HISTORY_METHOD_REPLACE } from '../../services/navigation/index'

export const pageStates = {
  GO_SKU: 'go-sku',
  GO_REDIRECT: 'go-redirect',
  GO_REMOTE_LOGIN: 'go-remote-login',
  GO_ADD_TO_PLAYLIST: 'go-add-to-playlist',
  GO_CREATE_PLAYLIST: 'go-create-playlist',
}

export const HOSTNAME = _get(global, ['location', 'hostname'], 'www.gaia.com')
export const HOSTNAME_REGEX = new RegExp(`^https?://${HOSTNAME}/?`, 'i')

export function getPageState (location) {
  const sku = _get(location, ['query', 'sku'])
  const addToPlaylist = _get(location, ['query', 'playlistAdd'])
  const createPlaylist = _get(location, ['query', 'playlistCreate'])
  const remoteLoginCode = _get(location, ['query', 'remoteLoginCode'])

  if (sku) {
    return pageStates.GO_SKU
  }
  if (addToPlaylist) {
    return pageStates.GO_ADD_TO_PLAYLIST
  }
  if (createPlaylist) {
    return pageStates.GO_CREATE_PLAYLIST
  }
  if (remoteLoginCode) {
    return pageStates.GO_REMOTE_LOGIN
  }

  return pageStates.GO_REDIRECT
}

export function handleRedirect ({
  history,
  auth,
  user = Map(),
  url = URL_HOME,
}) {
  const language = user.getIn(['data', 'language'])

  if (isFullUrl(url)) {
    if (HOSTNAME_REGEX.test(url)) {
      window.location.href = url
      return
    }
    historyRedirect({
      historyMethod: HISTORY_METHOD_REPLACE,
      url: URL_HOME,
      language,
      history,
      auth,
    })
    return
  }
  historyRedirect({
    historyMethod: HISTORY_METHOD_REPLACE,
    language,
    history,
    auth,
    url,
  })
}
